import React from 'react';
import './ServicesSection.css';

export interface Service {
  icon: string;
  title: string;
  description: string;
  className?: string;
}

interface ServicesSectionProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  services: Service[];
  stepped?: boolean;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({
  eyebrow,
  title,
  subtitle,
  services,
  stepped = false
}) => {
  return (
    <section className="services-section">
      <div className="section-container">
        <div className="section-header">
          {eyebrow && <div className="eyebrow centered">{eyebrow}</div>}
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {stepped ? (
          <div className="services-steps">
            {services.map((service, index) => (
              <div key={index} className="service-step">
                <div className="service-step-n">{String(index + 1).padStart(2, '0')}</div>
                <div className="service-step-body">
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className={`service-card ${service.className || ''}`}>
                <div className="service-icon">
                  <div className="icon-circle">{service.icon}</div>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ServicesSection;
